"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateModal = exports.addModal = exports.fetchModalsIfNeeded = exports.UPDATE_MODAL = exports.ADD_MODAL = exports.FETCH_MODALS = void 0;
var utils_1 = require("../../utils");
exports.FETCH_MODALS = (0, utils_1.networkActionTypes)("FETCH_MODALS");
exports.ADD_MODAL = (0, utils_1.networkActionTypes)("ADD_MODAL");
exports.UPDATE_MODAL = (0, utils_1.networkActionTypes)("UPDATE_MODAL");
var fetchModals = (0, utils_1.networkAction)(exports.FETCH_MODALS, "/modals");
exports.fetchModalsIfNeeded = (0, utils_1.makeIfNeededAction)(fetchModals, "modals");
var _addModal = (0, utils_1.networkAction)(exports.ADD_MODAL, "/modals", "POST");
var addModal = function (body, accessToken) { return function (dispatch, getState) {
    var state = getState();
    if (state.modals.isFetching || state.modals.isAdding || state.modals.isUpdating)
        return;
    return dispatch(_addModal(body, {}, accessToken));
}; };
exports.addModal = addModal;
var updateModal = function (modalID, modalData, accessToken) {
    return function (dispatch, getState) {
        var state = getState();
        if (state.modals.isFetching || state.modals.isAdding || state.modals.isUpdating)
            return;
        return dispatch((0, utils_1.networkAction)(exports.UPDATE_MODAL, "/modals/".concat(modalID), "PUT")(modalData, {}, accessToken));
    };
};
exports.updateModal = updateModal;
